var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('q-checkbox',_vm._g({attrs:{"value":_vm.value,"label":_vm.label,"disable":_vm.disable,"color":_vm.color,"keep-color":_vm.keepColor,"size":_vm.size,"dense":_vm.dense}},_vm.$listeners),[[(!_vm.label)?_vm._t("default"):_vm._e()]],2)}
var staticRenderFns = []

export { render, staticRenderFns }